import {createFileRoute} from "@tanstack/react-router";
import {z as zod} from "zod";
import {ErrorComponent} from "~/routes/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/w/$workspaceId/_defaultScaffold/user-invitation/-errorComponent";
import {NotFoundComponent} from "~/routes/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/w/$workspaceId/_defaultScaffold/user-invitation/-notFoundComponent";
import {PendingComponent} from "~/routes/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/w/$workspaceId/_defaultScaffold/user-invitation/-pendingComponent";
import {RouteComponent} from "~/routes/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/w/$workspaceId/_defaultScaffold/user-invitation/-routeComponent";
import {notFoundIfWorkspaceConfigPresent} from "~/workspaceConfig/notFoundIfWorkspaceConfigPresent";

export const Route = createFileRoute(
    "/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/w/$workspaceId/ottosync/_ottosyncScaffold/user-invitation",
)({
    validateSearch: zod.object({
        view: zod.enum(["table", "create"]).optional().default("table"),
    }),
    beforeLoad: ({context}) => {
        notFoundIfWorkspaceConfigPresent(context.workspace.id);
    },
    component: RouteComponent,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
